import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { productIdZodSchema } from "@@/shared/products/product-id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";
import { productFormFieldIdZodSchema } from "../fields/product-form-field-id";
import { productFormIdZodSchema } from "../product-form-id";

const productFormSortFieldsCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("PRODUCT_FORM_SORT_FIELDS_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    productId: productIdZodSchema,
    productFormId: productFormIdZodSchema,
    sortOrder: z.array(productFormFieldIdZodSchema),
});
type ProductFormSortFieldsCommand = z.infer<
    typeof productFormSortFieldsCommandZodObject
>;

const factoryParamsZodObject = productFormSortFieldsCommandZodObject.omit({
    _id: true,
    _type: true,
    _createdAt: true,
});
type FactoryParams = z.infer<typeof factoryParamsZodObject>;

const productFormSortFieldsCommandFactory = (
    params: FactoryParams,
): ProductFormSortFieldsCommand => {
    return {
        ...params,
        _id: generateId({ prefix: "product_form_sort_fields_command__" }),
        _type: "PRODUCT_FORM_SORT_FIELDS_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
};

export {
    productFormSortFieldsCommandFactory,
    factoryParamsZodObject as productFormSortFieldsCommandFactoryParamsZodObject,
    productFormSortFieldsCommandZodObject,
};
export type {
    ProductFormSortFieldsCommand,
    FactoryParams as ProductFormSortFieldsCommandFactoryParams,
};
